import { logWrapper } from '../../utils';

export default {
  securityController: [
    'runtimeConstant',
    '$rootScope',
    'authService',
    'EAdminFeatures',
    function (runtimeConstant, $rootScope, authService, EAdminFeatures) {
      'use strict';

      function run() {
        try {
          $rootScope.menus = [
            {
              title: 'ROLES',
              icon: 'md md-filter-none',
              ref: 'modules.security.roles',
              visible: authService.verifyHasAdminFeature,
              features: [EAdminFeatures.ManageRoles],
              enabled: true,
            },
            {
              title: 'GROUPS',
              icon: 'md md-people-outline',
              ref: 'modules.security.groups',
              visible: authService.verifyHasAdminFeature,
              features: [EAdminFeatures.ManageGroups],
              enabled: true,
            },
            {
              title: 'USERS',
              icon: 'md md-person-outline',
              ref: 'modules.security.users',
              visible: authService.verifyHasAdminFeature,
              features: [EAdminFeatures.ManageUsers],
              enabled: true,
            },
          ];
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      logWrapper(run, runtimeConstant.isDebugControllers)();
    },
  ],
};
